// extracted by mini-css-extract-plugin
module.exports = {"page":"tV","cartModal":"uV","checkout":"vV","account":"wV"};